// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__S8wIR","label":"Radio_label__19W_M","checkMark":"Radio_checkMark__AnOWd","disabled":"Radio_disabled__3Er93"};